export default __webpack_public_path__ + "static/media/side-img-1.1101c5fd.jpg";